import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import api from "@/lib/api";

/** /academy/success — polls the Stripe session then routes to the Academy dashboard. */
export default function AcademySuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/academy/checkout/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); setTimeout(() => nav("/dashboard/academy", { replace: true }), 1600); return; }
        if (data.payment_status === "expired") { setState("error"); return; }
      } catch { /* keep polling */ }
      if (++tries < 10) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "var(--ink-1)" }}>
      <div className="text-center px-6" data-testid="academy-success-page">
        {state === "paid" ? (
          <>
            <CheckCircle2 className="h-12 w-12 mx-auto text-emerald-400" />
            <h1 className="text-2xl font-black text-white mt-4">Academy membership active!</h1>
            <p className="text-sm text-white/50 mt-2">Taking you to your Academy dashboard…</p>
          </>
        ) : state === "checking" ? (
          <>
            <Loader2 className="h-10 w-10 mx-auto text-amber-300 animate-spin" />
            <p className="text-sm text-white/60 mt-4">Confirming your payment…</p>
          </>
        ) : (
          <>
            <h1 className="text-xl font-black text-white">We couldn't confirm the payment yet</h1>
            <p className="text-sm text-white/50 mt-2">Check your Academy dashboard — the membership activates automatically once payment settles.</p>
            <button onClick={() => nav("/dashboard/academy")} className="mt-4 text-sm underline text-amber-300" data-testid="academy-success-continue">Go to dashboard</button>
          </>
        )}
      </div>
    </div>
  );
}
